import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@app/shared/shared.module';
import { SettingsRoutingModule } from '@app/modules/settings/settings.routing';
import { TemplateManagementComponent } from '@app/modules/settings/pages/template-management/template-management.component';
import { TemplateCategoryComponent } from '@app/modules/settings/components/template-category/template-category.component';
import { TemplateComponent } from '@app/modules/settings/components/template/template.component';
import { UserManagementComponent } from '@app/modules/settings/pages/user-management/user-management.component';
import { ClientUserComponent } from '@app/modules/settings/components/client-user/client-user.component';
import { OfficeManagementComponent } from '@app/modules/settings/pages/office-management/office-management.component';
import { OfficeComponent } from '@app/modules/settings/components/office/office.component';
import { DepartmentDialogComponent } from '@app/modules/settings/components/dialogs/department-dialog.component';
import { DepartmentManagementComponent } from '@app/modules/settings/pages/department-management/department-management.component';
import { DepartmentComponent } from '@app/modules/settings/components/department/department.component';
import { ThirdPartyCredentialsManagementComponent } from '@app/modules/settings/pages/third-party-credentials-management/third-party-credentials-management.component';
import { CredentialsComponent } from '@app/modules/settings/components/credentials/credentials.component';
import { EmailCredentialsComponent } from '@app/modules/settings/components/credentials/email-credentials/email-credentials.component';
import { AddressBookEntryComponent } from '@app/modules/settings/components/address-book-entry/address-book-entry.component';
import { AddressBookManagementComponent } from '@app/modules/settings/pages/address-book-management/address-book-management.component';
import { RecipientOptionsManagementComponent } from '@app/modules/settings/pages/recipient-options-management/recipient-options-management.component';
import { RecipientOptionsComponent } from '@app/modules/settings/components/recipient-options/recipient-options.component';
import { CaseNumberManagementComponent } from '@app/modules/settings/pages/case-number-management/case-number-management.component';
import { CaseNumberStructureComponent } from '@app/modules/settings/components/case-number-structure/case-number-structure.component';
import { CaseSettingsManagementComponent } from '@app/modules/settings/pages/case-settings-management/case-settings-management.component';
import { WorkInstructionsComponent } from '@app/modules/settings/components/work-instructions/work-instructions.component';
import { WorkflowManagementComponent } from '@app/modules/settings/pages/workflow-management/workflow-management.component';
import { WorkflowTargetComponent } from '@app/modules/settings/components/workflow-target/workflow-target.component';
import { CaseWorkflowParticipantsComponent } from '@app/modules/settings/components/case-workflow-participants/case-workflow-participants.component';
import { CaseWorkflowDistributionComponent } from '@app/modules/settings/components/case-workflow-distribution/case-workflow-distribution.component';
import { SettingsOverviewComponent } from '@app/modules/settings/pages/settings-overview/settings-overview.component';
import { SettingsWidgetComponent } from './components/settings-widget/settings-widget.component';


@NgModule({
    declarations: [
        AddressBookEntryComponent,
        AddressBookManagementComponent,
        CaseNumberManagementComponent,
        CaseNumberStructureComponent,
        CaseSettingsManagementComponent,
        CaseWorkflowDistributionComponent,
        CaseWorkflowParticipantsComponent,
        ClientUserComponent,
        CredentialsComponent,
        DepartmentDialogComponent,
        DepartmentManagementComponent,
        DepartmentComponent,
        EmailCredentialsComponent,
        OfficeComponent,
        OfficeManagementComponent,
        RecipientOptionsComponent,
        RecipientOptionsManagementComponent,
        SettingsOverviewComponent,
        SettingsWidgetComponent,
        TemplateCategoryComponent,
        TemplateComponent,
        TemplateManagementComponent,
        ThirdPartyCredentialsManagementComponent,
        UserManagementComponent,
        WorkInstructionsComponent,
        WorkflowManagementComponent,
        WorkflowTargetComponent
    ],
    imports: [
        CommonModule,
        SharedModule,
        SettingsRoutingModule
    ]
})
export class SettingsModule { }
